function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Artwork",
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.1",
  width: "30",
  height: "30",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("path", {
  className: styles["cls-1"] || "cls-1",
  d: "M21.542 16.749H2.458a.5.5 0 000 1h19.084a.5.5 0 000-1zM2.458 15.014h19.084a.5.5 0 000-1h-6.744c-.685 0-1.029-.829-.544-1.313l4.763-4.765v1.81a.5.5 0 001 0V6.751a.5.5 0 00-.5-.5h-3.04a.5.5 0 000 1h1.811l-6.394 6.396-6.125-2.853a.5.5 0 10-.422.906l3.239 1.508c.409.191.273.804-.178.804h-5.95a.5.5 0 000 1z"
})));